// extracted by mini-css-extract-plugin
export default {"login_btn":"Login_login_btn__0Ruj9","login_card":"Login_login_card__1b0zM"};